<template>
   <div v-if="journeys && journeys.length > 0" class="journeys d-flex flex-column">
      <div class="journeys-header d-flex justify-content-center align-items-center w-100">
         {{ $t('dashboard.discover') }}
      </div>

      <journeyCard v-for="journey in journeys" :key="journey.id" :journey="journey" />
   </div>
   <div v-else-if="journeys && journeys.length == 0">
      <div class="d-flex justify-content-center align-items-center w-100">
         {{ $t('dashboard.no_journeys_found') }}
      </div>
   </div>

   <div v-else class="h-100 d-flex flex-column justify-content-center">
      <LoadingAnimation :color="'Grey'" />
   </div>
</template>

<script>
import globalValues from '@/core/helpers/enums/globalValues';
import RouterPush from '@/core/helpers/routerPush';
import { bus } from '@/main';
import journeyCard from '@/modules/journeys/components/journeyCard.vue';
const routerPush = new RouterPush();

export default {
   components: {
      LoadingAnimation: () => import('@/core/components/LoadingAnimation'),
      journeyCard,
   },

   data() {
      return {
         journeys: null,
         journey_id: sessionStorage.getItem('journey_id'),
      };
   },

   created() {
      sessionStorage.removeItem(globalValues.candidate.submissionId);
      sessionStorage.removeItem(globalValues.candidate.stepId);
      const candidateBody = {
         email: sessionStorage.getItem(globalValues.candidate.email),
         phone: sessionStorage.getItem(globalValues.candidate.phone_number),
      };

      if (!this.$route.query.journey_nxt_id) {
         this.journeys = [];
      } else {
         let calls = [this.$store.dispatch('getJourneys', { journeyNxtId: this.$route.query.journey_nxt_id })];

         if (candidateBody.phone) {
            calls.push(this.$store.dispatch('getCandidateByMail', candidateBody));
         }

         Promise.all(calls).then((response) => {
            this.journeys = response[0];
         });
      }
   },

   mounted() {
      bus.$emit('setBackgroundImage');
      this.$emit('showMainBar');
   },

   computed: {},

   methods: {
      openJourney(journey) {
         routerPush.toJourney(journey);
      },
   },
};
</script>

<style>
.grecaptcha-badge {
   visibility: hidden;
   opacity: 0;
}
</style>

<style lang="scss" scoped>
.journeys {
   padding-top: 55px;
   background-color: #fafafa;
   // padding: 129px 32px !important;

   @media (min-width: 769px) {
      justify-content: center;
      // padding-top: 147px !important;
      flex-wrap: wrap;
      flex-direction: row !important;
      align-content: flex-start !important;
   }

   &-header {
      z-index: 2;
      top: 0px;
      left: 0;
      position: fixed;
      height: 67px;
      font-size: 1.3rem;
      background-color: #eee;
      color: #0cd0f0;
      color: var(--primaryColor);

      // @media (min-width: 769px) {
      //    top: 80px;
      // }
   }

   &-journey {
      z-index: 1;
      @media (min-width: 769px) {
         width: 270px;
         min-height: 150px;
      }

      min-height: 120px;
      background-color: #fff;
      border-radius: 5px;
      box-shadow: 0 1px 0.5px 0 rgba(0, 0, 0, 0.2), 0 1px 2px 0 rgba(0, 0, 0, 0.2);

      &-image {
         max-width: 65px;
         max-height: 65px;
      }

      &-button {
         width: 160px;
         cursor: pointer;
         // height: 36px;
         font-size: 0.9rem;
         padding: 7.5px 20px;
         color: white;
         background-color: #0cd0f0;
         background-color: var(--primaryColor);
         border: none;
         border-radius: 6px;
      }

      &-name {
         white-space: nowrap;
         overflow: hidden;
         text-overflow: ellipsis;
      }

      &-busy {
         position: absolute;
         right: 0;
         background-color: #e99800;
         text-transform: uppercase;
         border-radius: 50px;
         font-size: 0.7rem;
         color: white;
         height: 18px;
         width: 90px;
      }
   }
}

.journeys-journey:nth-of-type(2),
.journeys-journey:nth-of-type(3),
.journeys-journey:nth-of-type(4) {
   margin-top: 80px !important;
}
</style>

